export type MaasTaskRunStrategy = 'Parallel' | 'Sequential' | 'Single' | 'Stepwise';
export type MaasTaskFailurePolicy = 'Terminate' | 'Skip' | 'Pause';
export type MaasTaskRole = 'All' | 'Head' | 'Worker';

/** 任务步骤 API 结构（与 maas.json taskTemplate 对齐） */
export interface MaasTaskTemplateStep {
  name: string;
  role: MaasTaskRole;
  groups?: string[];
  command: {
    commands: string[];
    args?: string[];
    timeout?: number;
    retryCount?: number;
  };
  runStrategy: MaasTaskRunStrategy;
  failurePolicy: MaasTaskFailurePolicy;
  /** 是否异步执行，默认 false（同步执行） */
  async?: boolean;
  /** 依赖的前置任务名称列表 */
  dependsOn?: string[];
}

/** 任务步骤弹窗表单值（含 command 辅助字段） */
export interface MaasTaskStepFormValues {
  name: string;
  role: MaasTaskRole;
  groups?: string[];
  runStrategy: MaasTaskRunStrategy;
  failurePolicy: MaasTaskFailurePolicy;
  /** 是否异步执行，默认 false（同步执行） */
  async?: boolean;
  /** 依赖的前置任务名称列表 */
  dependsOn?: string[];
  timeoutSeconds?: number;
  retryCount?: number;
  command?: {
    _shellType?: 'bash' | 'sh';
    _commandsText?: string;
    _argsText?: string;
  };
}

export const TASK_TEMPLATE_FIELD = 'taskTemplate';

export const DEFAULT_TASK_STEP: Omit<MaasTaskStepFormValues, 'name'> = {
  role: 'All',
  runStrategy: 'Parallel',
  failurePolicy: 'Terminate',
  async: false,
  dependsOn: [],
  retryCount: 0,
};
